import React from 'react';
import { TextField, TextFieldProps, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

type StyledSearchFieldProps = TextFieldProps & {
  onClear?: () => void;
};

const StyledSearchField: React.FC<StyledSearchFieldProps> = ({ onClear, ...props }) => {
  return (
    <TextField
      {...props}
      sx={{
        '& .MuiOutlinedInput-root': {
          bgcolor: 'var(--surface-base)',
          borderRadius: 'var(--radius-none)',
          border: 'var(--elevation-1)',
          boxShadow: 'none',
          '& fieldset': {
            border: 'none',
          },
          '&:hover': {
            borderColor: 'var(--border-default)',
            transform: 'none',
          },
          '&.Mui-focused': {
            outline: 'var(--focus-ring)',
            outlineOffset: 0,
            borderColor: 'transparent',
            '& fieldset': {
              border: 'none',
            },
          },
          transition: 'all var(--duration-base) var(--easing)',
        },
        '& .MuiInputBase-input': {
          fontSize: 'var(--text-sm)',
          fontFamily: 'var(--font-data)',
          color: 'var(--text-primary)',
          '&::placeholder': {
            color: 'var(--text-placeholder)',
            opacity: 1,
          },
        },
        '& .MuiInputLabel-root': {
          fontSize: 'var(--text-sm)',
          fontFamily: 'var(--font-data)',
          color: 'var(--text-secondary)',
          '&.Mui-focused': {
            color: 'var(--text-primary)',
          },
        },
        '& .MuiInputAdornment-root': {
          '& .MuiSvgIcon-root': {
            fontSize: '1.25rem',
            color: 'var(--text-secondary)',
          },
        },
        ...props.sx,
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: 'var(--text-secondary)', fontSize: '1.25rem' }} />
          </InputAdornment>
        ),
        ...props.InputProps,
      }}
    />
  );
};

export default StyledSearchField;
